// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e15d5d76","805":"f28b0701"}[chunkId] + ".chunk.js";
};